import React from "react";
import cx from "classnames";
import styles from "./loaders.module.scss";
import _ from "lodash";

interface ILoader {
  count: number;
}
export const ConversationDetailLoader = () => {
  return (
    <div className={cx(styles.placeholder, styles.details)}>
      <span className={cx(styles.title, styles.block)} />

      <span className={cx(styles.subTitle, styles.block)} />
      <span className={cx(styles.lastShared, styles.block)} />

      <div className={styles.analytics}>
        <div className={cx(styles.analyticsItem, styles.block)} />
        <div className={cx(styles.analyticsItem, styles.block)} />
        <div className={cx(styles.analyticsItem, styles.block)} />
      </div>

      <div className={styles.tabs}>
        <div className={cx(styles.tab, styles.block)} />
        <div className={cx(styles.tab, styles.block)} />
      </div>
    </div>
  );
};

export const RecipientLoader: React.FC<ILoader> = ({ count }) => {
  return (
    <>
      {_.times(count, (index) => (
        <div className={cx(styles.placeholder, styles.recipient)} key={index}>
          <div className={cx(styles.avatar, styles.block)} />
          <div className={styles.info}>
            <span className={cx(styles.title, styles.block)} />
            <span className={cx(styles.subTitle, styles.block)} />
          </div>
        </div>
      ))}
    </>
  );
};

export const SectionShareLoader: React.FC<ILoader> = ({ count }) => {
  return (
    <>
      {_.times(count, (index) => (
        <div
          className={cx(styles.placeholder, styles.sectionShare)}
          key={index}
        >
          <span className={cx(styles.title, styles.block)} />
          <span className={cx(styles.subTitle, styles.block)} />
        </div>
      ))}
    </>
  );
};

export const AssetShareLoader: React.FC<ILoader> = ({ count }) => {
  return (
    <>
      {_.times(count, (index) => (
        <div className={cx(styles.placeholder, styles.assetShare)} key={index}>
          <div className={cx(styles.icon, styles.block)} />
          <div className={styles.info}>
            <span className={cx(styles.title, styles.block)} />
            <span className={cx(styles.subTitle, styles.block)} />
          </div>
        </div>
      ))}
    </>
  );
};

export const ShareLoader: React.FC<ILoader> = ({ count }) => {
  return (
    <>
      {_.times(count, (index) => (
        <div className={cx(styles.share, styles.placeholder)} key={index}>
          <div className={styles.info}>
            <div className={cx(styles.title, styles.block)} />
            <div className={cx(styles.subTitle, styles.block)} />
            <div className={cx(styles.assetCount, styles.block)} />
          </div>
          <div className={styles.analytics}>
            <div className={cx(styles.metrics, styles.block)} />
            <div className={cx(styles.metrics, styles.block)} />
            <div className={cx(styles.metrics, styles.block)} />
          </div>
        </div>
      ))}
    </>
  );
};

export const ContactLoader = () => {
  return (
    <div className={cx(styles.placeholder, styles.contact)}>
      <div className={cx(styles.avatar, styles.block)} />
      <div className={styles.info}>
        <span className={cx(styles.title, styles.block)} />
        <span className={cx(styles.subTitle, styles.block)} />
        <span className={cx(styles.tags)}>
          <span className={cx(styles.tag, styles.block)} />
          <span className={cx(styles.tag, styles.block)} />
        </span>
      </div>
    </div>
  );
};

export const TimeLineLoader: React.FC<ILoader> = ({ count }) => {
  return (
    <div className={cx(styles.timeLine, styles.placeholder)}>
      {_.times(count, (index) => (
        <div className={styles.item} key={index}>
          <div className={cx(styles.dot, styles.block)} />
          <div className={cx(styles.event, styles.block)} />
        </div>
      ))}
    </div>
  );
};

export const DealLoader: React.FC<ILoader> = ({ count }) => {
  return (
    <>
      {_.times(count, (index) => (
        <div className={cx(styles.opportunity, styles.placeholder)} key={index}>
          <div className={cx(styles.title, styles.block)} />
          <div className={cx(styles.checkbox, styles.block)} />
        </div>
      ))}
    </>
  );
};

export const PreviewLoader = () => {
  return (
    <div className={cx(styles.preview, styles.placeholder)}>
      <div className={cx(styles.block, styles.recipients)} />
      <div className={cx(styles.block, styles.subject)} />
      <div className={cx(styles.body)}>
        <div className={cx(styles.block, styles.line1)} />
        <div className={cx(styles.block, styles.line2)} />
        <div className={cx(styles.block, styles.line3)} />
        <div className={cx(styles.assets)}>
          {_.times(4, (index) => (
            <div className={cx(styles.asset, styles.block)} key={index} />
          ))}
        </div>
      </div>
    </div>
  );
};

export const ActivityLoader: React.FC<ILoader> = ({ count }) => {
  return (
    <>
      {_.times(count, (index) => (
        <div className={cx(styles.activity, styles.placeholder)} key={index}>
          <div className={cx(styles.info, styles.block)} />
          <div className={cx(styles.info, styles.block)} />
          <div className={cx(styles.info, styles.block)} />
          <div className={cx(styles.info, styles.block)} />
        </div>
      ))}
    </>
  );
}